export default function handleBool({ oldValue, newValue }) {
    if (newValue == true || newValue == '1' || newValue == 'true') {
        return true
    }
    if (newValue == false || newValue == '0' || newValue == 'false') {
        return false
    }
    return oldValue
}